import { apiActions } from '../../../_core/api';
import { Middleware } from 'redux';
import { IStore } from '../../../store';
import ballastActions, {
    EBallastActions,
    EBallastConstants,
    TBallastActions,
} from '../actions';
import { jobActions } from '../../../_core/job';
import { IAuthActions } from '../../auth/actions';
import { commonUtils } from '../../../_common';
import { TBallastBackendRecord } from '../@types';
import { EMARPOLDocuments, EMARPOLModelName } from '../../marpol/@types';

const ballastHistoryMiddleware: Middleware<{}, IStore> =
    ({ dispatch, getState }) =>
    (next) =>
    (action: TBallastActions | IAuthActions) => {
        switch (action.type) {
            case EBallastActions.HISTORY_LOAD: {
                next(action);
                const job = jobActions(EBallastConstants.FEATURE, action.type);
                const { providedFilters: filters } = action.payload;
                dispatch(ballastActions.document.setFilter(filters));
               
                dispatch(
                    apiActions.apiRequest<{ logs: { docs: TBallastBackendRecord[] } }>({
                        feature: action.type,
                        method: 'GET',
                        url: EBallastConstants.API,
						queryParams: {
							vesselId: filters.vesselId,
							marpolType: EMARPOLDocuments.BALLAST_WATER_RECORD_OPERATION,
							modelName: EMARPOLModelName.MARPOL,
							weekStart: filters.startDate,
							weekEnd: filters.endDate,
							state: {
								$eq: filters?.state ?? undefined
							},
							sortOrder: filters?.sortOrder ?? undefined,
						},
                        preExecute() {
                            dispatch(job.active({}));
                        },
						postExecute: {
							onSuccess({ data }) {
								const ballastRecords = data.logs.docs.filter(
									(doc) => doc.marpolType === EMARPOLDocuments.BALLAST_WATER_RECORD_OPERATION
								);
								dispatch(
									ballastActions.document.historySet(
										commonUtils.arrayToObject(ballastRecords)
									)
								);
                                dispatch(job.success({}));
                            },
                            onError() {
                                dispatch(job.error({}));
                            },
                            finally() {
                                dispatch(job.idle({}));
                            },
                        },
                    })
                );
                break;
            }
            default: {
                next(action);
                break;
            }
        }
    };
export default ballastHistoryMiddleware;
